import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { IAppState } from 'app/store';
import { PermissionsetService } from 'app/shared/services/permissionset.service';
import { Permissionset } from 'app/shared/models/permissionset';
import { PermissionsetKey } from 'app/shared/models/keys/permissionset-key';
import { KeyBase, IEntity, ItemAdded, ItemChanged } from '@kpd/framework-ngx';
import { environment } from 'environments/environment';
import { UserManagementEntityFacade } from './usermanagement.facade';

@Injectable()
export class PermissionsetFacade extends UserManagementEntityFacade {
  constructor(private permissionSetService: PermissionsetService, store: Store<IAppState>) {
    super('permissionSets', store, permissionSetService, environment);
  }

  saveItem(permissionSet: Permissionset): Observable<Permissionset> {
    const subject = new Subject<Permissionset>();
    this.permissionSetService.save(permissionSet).subscribe(
      updatedPermissionSet => {
        if (permissionSet.isNew()) {
          this.store.dispatch(new ItemAdded('permissionSets', updatedPermissionSet));
        } else {
          this.store.dispatch(new ItemChanged('permissionSets', updatedPermissionSet, permissionSet.key));
        }

        subject.next(updatedPermissionSet);
        subject.complete();
      },
      error => {
        subject.error(error);
        subject.complete();
      },
    );
    return subject;
  }

  composeKeyByRouteParams(params: { permissionSetId: string; applicationId: string; type?: string }): KeyBase {
    return PermissionsetKey.composeKeyByRouteParams(params);
  }

  createNewEntity(): IEntity {
    return new Permissionset();
  }
}
